import buildUrl from './buildUrl';

const buildDashboardUrl = (
  pattern: string,
  {
    pathParams,
    queryParams
  }: {
    pathParams?: Record<string, unknown>;
    queryParams?: Record<string, unknown>;
  } = {}
) =>
  buildUrl(pattern, {
    pathParams,
    queryParams,
    host: process.env.REACT_APP_BACKEND_DASHBOARD_BASE_URL || ''
  });

export default buildDashboardUrl;
